let apiAppUrl = process.env.URL_API;
const { reduce } = require('lodash/collection');
const { slice } = require('lodash/array');
const isDevelopment = process.env.NODE_ENV === 'development';

let NavigationUtils = {

    /**
     * Change url location to given page.
     */
    goTo(page, queryParams) {
        if (isDevelopment) {
            apiAppUrl = 'http://127.0.0.1:8000';
        }
        window.location = queryParams ? `${apiAppUrl}/#/${page}?${this.formatQueryParams(slice(arguments, 1))}` : `${apiAppUrl}/#/${page}`;
    },
    
    goToForce(page, queryParams) {
        if (isDevelopment) {
            apiAppUrl = 'http://127.0.0.1:8000';
        }
        const url = queryParams ? `${apiAppUrl}/#/${page}?${this.formatQueryParams(slice(arguments, 1))}` : `${apiAppUrl}/#/${page}`;
        window.location.push(url);
    },

    /**
     * Change url location to given page.
     */
    goToText(page, textId) {
        if (isDevelopment) {
            apiAppUrl = 'http://127.0.0.1:8000';
        }
        window.location = `${apiAppUrl}/#/${page}#${textId}`;
    },

    /**
     * Concat with `&` operator given the query params.
     */
    formatQueryParams(queryParams) {
        return reduce(queryParams, (paramBefore, paramAfter) => `${paramBefore}&${paramAfter}`);
    },

    /**
     * Retrieve the next path params defined.
     */
    getPathParam(param){
        const pathParams = window.location.hash.split('/');
        const targetIndex = pathParams.indexOf(param) + 1;
        const paramValue = pathParams[targetIndex];
        if (paramValue && paramValue.split) {
            return paramValue.split('?')[0];// remove to the last param the query params
        } else {
            return paramValue;
        }
    },

    /**
     * Retrieve the query params defined
     */
    getQueryParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

};

module.exports = NavigationUtils;



/** WEBPACK FOOTER **
 ** ./src/utils/NavigationUtils.js
 **/